import CaseFirstViewWhite from 'components/cases/common/CasesFirstViewWhite/'
import OverView from 'components/cases/common/Overview/'
import Interview from 'components/cases/aldagram/Interview/Interview'
import CaseStudyNew from '../../home/CaseStudy/CaseStudyNew'
import { firstViewItemWhite, overviewItem, overviewTitle, issueSolutionItems, caseCTAItem } from './aldagramItems'
import styles from './aldagram.module.scss'
import CaseCTA from 'components/cases/common/CaseCTA'
import FooterCTA from 'components/common/FooterCTA'

const Aldagram = (): JSX.Element => {
  return (
    <>
      <CaseFirstViewWhite firstViewItemWhite={firstViewItemWhite} />
      <OverView overviewItem={overviewItem} issueSolutionItems={issueSolutionItems} overviewTitle={overviewTitle} />
      <Interview />
      <CaseCTA {...caseCTAItem} />
      <FooterCTA />
      <div className={styles.line}>
        <CaseStudyNew />
      </div>
    </>
  )
}

export default Aldagram
